var cell_default = {
  "cell": "pWVgE",
  "header": "_92OSM",
  "selected": "_-4qMN",
  "editing": "wHvSy",
  "singleSelection": "jMB22",
  "hideLastBlock": "m5V4D",
  "editorWrapper": "lWxG-",
  "viewerWrapper": "dDlqT",
  "hideFirstBlock": "Rc3ti",
  "editor": "IHA3b",
  "edit": "HIInO",
  "view": "JFavY",
  "editingToolbarWrapper": "-iP9h",
  "selectAll": "mRRwT",
  "disableSelection": "_9rIpg"
};
export {
  cell_default as default
};
//# sourceMappingURL=cell-scss.js.map
